import clsx from 'clsx';
import React, { useCallback } from 'react';

import { ICONS } from '@/src/components/common/Elements/Icon/Icon';
import Spinner from '@/src/components/common/Elements/Spinner/Spinner';
import { isResponseError } from '@/src/components/project/Inbox2/api/config';
import { showToast } from '@/src/globalFunction';

import ActionButton from '../../../../../../Elements/ActionButton/ActionButton';
import { useValidateActionResponse } from '../../../../useValidateActionResponse';
import { useFileEntryViewerSidebarActions } from '../../../store/fileEntryViewer.sidebarActions.store';

const getLabel = (isMisc) => {
  return isMisc ? 'Unmark as Miscellaneous' : 'Mark as Miscellaneous';
};

const getSuccessMessage = (isMisc) => {
  return isMisc ? 'Unmarked as Miscellaneous' : 'Marked as Miscellaneous';
};

type MarkMiscellaneousProps = {
  inboxEntryId: number;
  isMisc: boolean;
  onSuccess?: (response: any) => void;
};
const MarkMiscellaneous = ({ inboxEntryId, isMisc, onSuccess }: MarkMiscellaneousProps) => {
  const label = getLabel(isMisc);
  const { sidebarActions } = useFileEntryViewerSidebarActions();
  const markMiscellaneousMutation = sidebarActions.markMiscellaneousMutation;
  const { confirmRefreshModal } = useValidateActionResponse({
    responseError: isResponseError(markMiscellaneousMutation.data)
      ? markMiscellaneousMutation.data
      : null,
  });

  const handleMarkMiscellaneous = useCallback(async () => {
    const response = await markMiscellaneousMutation.mutateAsync({
      misc: !isMisc,
    });

    if (response) {
      if (onSuccess) {
        onSuccess(response);
      }
      showToast('success', getSuccessMessage(isMisc));
    }
  }, [isMisc, markMiscellaneousMutation, onSuccess]);

  return (
    <React.Fragment>
      {markMiscellaneousMutation.isLoading && <Spinner />}
      <ActionButton
        id={`markMiscellaneous_${inboxEntryId}`}
        className={clsx(isMisc && 'active')}
        onClick={handleMarkMiscellaneous}
        icon={ICONS.miscellaneous_icon({
          mainClassName: clsx(
            'group-hover:tw-fill-cfo-blue-700 group-hover:tw-stroke-cfo-blue-700',
            isMisc && 'tw-fill-cfo-blue-700 tw-stroke-cfo-blue-700'
          ),
          fillClassName: clsx('group-hover:tw-fill-white', isMisc && 'tw-fill-white'),
        })}
        tooltipSettings={{
          content: label,
          place: 'left',
        }}
      />
      {confirmRefreshModal}
    </React.Fragment>
  );
};

export default MarkMiscellaneous;
